// Dependencies
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'Components';
// Components
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Input, Form } from 'Components';
import { NotificationManager } from 'Components/Notifications';
// Material UI
import {
  Typography
} from '@mui/material';
// Actions
import { clipRequestOpenModalAddNotes } from 'Redux/actions'
import { useClipRequestDetail, useUpdateClipRequest } from 'Modules/video/.globals/api/clipRequests';

// Styles
import './styles.scss'

const ClipRequestAddNote = (props) => {
  const { messages } = props;
  const dispatch = useDispatch();
  const videoDetailForm = useRef();

  const { clipRequest: data, clipRequestOpenModal: open } = useSelector((state) => state.clipsRedux);

  const [currentNote, setCurrentNote] = useState('');

  // staleTime 0: el modal siempre muestra la nota vigente al abrirse.
  const { data: mediaResponse, isFetching: loadingClipRequest } = useClipRequestDetail(data?.id, {
    enabled: Boolean(data?.id && open),
    staleTime: 0,
  });

  const handleClose = () => {
    dispatch(clipRequestOpenModalAddNotes(false, null));
    setCurrentNote('');
  }

  const { mutate: saveNote, isPending: loadingUpdate } = useUpdateClipRequest({
    onSuccess: () => {
      NotificationManager.success(
        messages['videoMainView_noteAdded'],
        messages['success'],
        3000,
        null,
        null,
        'success',
      );
      handleClose();
    },
    onError: () => {
      NotificationManager.error(
        messages['errorMessage'],
        messages['error'],
        3000,
        null,
        null,
        'warning',
      );
    },
  });

  const handleNote = () => {
    saveNote({
      id: mediaResponse.id,
      notes: currentNote,
      starred: mediaResponse.starred
    })
  }

  useEffect(() => {
    if (mediaResponse && open) {
      mediaResponse.notes && setCurrentNote(mediaResponse.notes)
    }
  }, [mediaResponse, open]);

  return (
    <Modal
      size="small"
      position="right"
      open={open}
      loading={loadingClipRequest || loadingUpdate}
      title={mediaResponse?.notes ? messages['videoClipRequest_updateNote'] : messages['videoClipRequest_addNote']}
      handleClose={handleClose}
    >
      <ModalBody>
        <div
          style={{ padding: 24, height: 450 }}
        >
          <Typography
            variant="subtitle2"
            color="textSecondary"
          >
            {data?.label}
          </Typography>

          <Form ref={videoDetailForm} onValidSubmit={handleNote}>
            <Input
              label={messages['videoMainView_note']}
              placeholder={messages['videoMainView_note']}
              type="textarea"
              value={currentNote}
              maxLength={1000}
              onChange={(value) => setCurrentNote(value)}
            />
          </Form>
        </div>
      </ModalBody>
      <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
        <Button
          type="button"
          onClick={() => {
            handleClose()
          }}
          className="btn-cancel"
          disabled={loadingClipRequest || loadingUpdate}
        >
          {messages['cancel']}
        </Button>
        <Button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            videoDetailForm.current.submit();
          }}
          className="btn-blue"
          disabled={loadingClipRequest || loadingUpdate}
        >
          {mediaResponse?.notes
            ? messages['update']
            : messages['add']
          }
        </Button>
      </ModalFooter>
    </Modal>
  )

}

export default ClipRequestAddNote;